<div class="topbar" [class]="cssClasses()">
  <div class="content">
    <div class="topbar__left">
      <ng-content select="left"></ng-content>
    </div>
    <div class="topbar__right">
      <ng-content select="right"></ng-content>
    </div>
  </div>
</div>
